'use strict';

const i18n = require('i18next');
const ActionUpdateService = require('process/app/service/action/update');

class Service {
    constructor(action, state) {
        this._action = action;
        this._state = state;
    }

    proceed() {
        const project = this._action.getProject();
        let actionJSON = this._action.toJSON();
        actionJSON.state = this._state.id;

        const msg = i18n.t('process:feedback.proceedState', {
            name: this._action.getName(),
            stateName: this._state.getName()
        });

        return (new ActionUpdateService(
            project, this._action.id, actionJSON, msg))
            .update();
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./process/app/service/action/state.js